import footerApiFactory from '../../modules/footer/footerApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getFooterItemsActionCreators,
} from '../actions/footerActions';

function footerSagasFactory({storefrontApiClient}) {
  const footerApi = footerApiFactory(storefrontApiClient);

  const getFooterItemsSaga = generateDefaultAsyncSaga(
    footerApi.getFooterItems,
    getFooterItemsActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetFooterItems = generateDefaultAsyncWatcher(
    'GET_FOOTER_ITEMS',
    getFooterItemsSaga
  );

  const footerSagas = [
    watchGetFooterItems(),
  ];

  return footerSagas;
}

export default footerSagasFactory
;
